export default "__VITE_ASSET__Bdb6pcOU__"